<template>
    <div class="elements-to-display-wrapper" :style="{'background-image': `url(${elementToDisplay.imageUrl})`}">
        <transition name="animate-elements-change" mode="out-in">
            <div :key="`elementToDisplay${positionToDisplay}`" class="element-to-display" :style="{'background-image': `url(${elementToDisplay.imageUrl})`}">
                <div class="client-type-tag">{{getClientType === 'particular' ? t('login.publicity.particular') : t('login.publicity.company')}}</div>
                <div class="title">{{ elementToDisplay.title }}</div>
                <div class="description">{{ elementToDisplay.description }}</div>
                <button-primary buttonSize="small" :label="elementToDisplay.butttonName" @clicked="openExternalLink"/>
            </div>
        </transition>
        <div class="buttons-wrapper">
            <button-tertiary icon="arrow-left" buttonSize="small" :disabled="positionToDisplay === 0" @clicked="positionToDisplay--"/>
            <button-tertiary icon="arrow-right" buttonSize="small" :disabled="positionToDisplay === (arrayToDisplay.length - 1)" @clicked="positionToDisplay++"/>
        </div>
    </div>
</template>

<script setup>
import ButtonPrimary from '@/components/generic/buttons/Primary'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
/* vue */
import { ref, computed, watch } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapGetter */
const { getClientType } = mapGetters()

const positionToDisplay = ref(0)

const particularArray = [{
    title: t('login.publicity.particular1.title'),
    description: t('login.publicity.particular1.description'),
    butttonName: t('login.publicity.knowMoreButton'),
    imageUrl: './images/login/particular_1.jpg',
    buttonLink: t('login.publicity.particular1.url')
}, {
    title: t('login.publicity.particular2.title'),
    description: t('login.publicity.particular2.description'),
    butttonName: t('login.publicity.knowMoreButton'),
    imageUrl: './images/login/particular_2.jpg',
    buttonLink: t('login.publicity.particular2.url')
}, {
    title: t('login.publicity.particular3.title'),
    description: t('login.publicity.particular3.description'),
    butttonName: t('login.publicity.knowMoreButton'),
    imageUrl: './images/login/particular_3.jpg',
    buttonLink: t('login.publicity.particular3.url')
}]

const companyArray = [{
    title: t('login.publicity.company1.title'),
    description: t('login.publicity.company1.description'),
    butttonName: t('login.publicity.knowMoreButton'),
    imageUrl: './images/login/company_1.jpg',
    buttonLink: t('login.publicity.company1.url')
}, {
    title: t('login.publicity.company2.title'),
    description: t('login.publicity.company2.description'),
    butttonName: t('login.publicity.knowMoreButton'),
    imageUrl: './images/login/company_2.jpg',
    buttonLink: t('login.publicity.company2.url')
}, {
    title: t('login.publicity.company3.title'),
    description: t('login.publicity.company3.description'),
    butttonName: t('login.publicity.knowMoreButton'),
    imageUrl: './images/login/company_3.jpg',
    buttonLink: t('login.publicity.company3.url')
}]

const arrayToDisplay = computed(() => {
    return getClientType.value === 'particular' ? particularArray : companyArray
})

const elementToDisplay = computed(() => {
    return arrayToDisplay.value[positionToDisplay.value]
})

watch(() => getClientType.value, (newVal, oldVal) => {
    positionToDisplay.value = 0
})

const openExternalLink = () => {
    window.open(elementToDisplay.value.buttonLink, '_blank')
}
</script>

<style lang="scss" scoped>
.elements-to-display-wrapper {
		width: 50%;
		height: 100%;
		position: relative;

		flex-shrink: 0;

		border-radius: 0px 16px 16px 0px;

        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        overflow: hidden;

        &:after {
            content: '';
            width: 100%;
            height: 100%;

            position: absolute;
            top: 0;
            left: 0;

            background-color: #242526;
            opacity: 0.56;
            z-index: 1;
        }

        .element-to-display {
            width: 100%;
            height: 100%;
            padding: 24px;
            position: relative;

            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            gap: 8px;

            color: #FFFFFF;

            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;

            z-index: 2;
            opacity: 1;
            transition: all 0.1s linear;

            &.animate-elements-change-enter-active,
            &.animate-elements-change-leave-active {
                opacity: 1;
            }

            &.animate-elements-change-enter-from,
            &.animate-elements-change-leave-to {
                opacity: 0;
            }

            &:after {
                content: '';
                width: 100%;
                height: 100%;

                position: absolute;
                top: 0;
                left: 0;

                background-color: #242526;
                opacity: 0.56;
                z-index: 1;
            }

            .client-type-tag {
                width: fit-content;
                height: 24px;
                padding: 0 8px;
                position: relative;

                @include H8-Medium;
                line-height: 24px;

                border-radius: 4px;
                border: 1px solid #DEDEDE;
                z-index: 2;
            }

            .title {
                position: relative;

                @include H1-SemiBold;
                z-index: 2;
            }

            .description {
                position: relative;

                @include H5-Regular;
                line-height: normal;
                z-index: 2;
            }

            .button-primary {
                position: relative;
                margin-top: 8px;
                z-index: 2;
            }
        }

        .buttons-wrapper {
            width: auto;

            display: flex;
            gap: 8px;

            position: absolute;
            right: 24px;
            bottom: 24px;
            z-index: 3;
        }
	}
</style>
